import { createStyles, makeStyles, Theme } from '@material-ui/core';

const textoInformativoStyles = makeStyles((theme: Theme) =>
  createStyles({
    titulo: {
      position: 'relative',
      textAlign: 'center',
      marginBottom: '.5rem',
      [theme.breakpoints.down('sm')]: {},
    },
    textoBajada: {
      position: 'relative',
      textAlign: 'center',
      width: '100%',
      margin: '0 auto',
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
      },
    },
  })
);

export default textoInformativoStyles;
